<h2 mat-dialog-title class="change-password-dialog-header sl-flexbox-row">
	<span class="title">Change password</span>
</h2>
<mat-dialog-content>
	<sl-change-password (closeIt)="onClose()"></sl-change-password>
</mat-dialog-content>
